import { render, staticRenderFns } from "./comercial-trabaja.vue?vue&type=template&id=1bf50d44&scoped=true"
import script from "./comercial-trabaja.vue?vue&type=script&lang=js"
export * from "./comercial-trabaja.vue?vue&type=script&lang=js"
import style0 from "./comercial-trabaja.vue?vue&type=style&index=0&id=1bf50d44&prod&lang=css"
import style1 from "./comercial-trabaja.vue?vue&type=style&index=1&id=1bf50d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf50d44",
  null
  
)

export default component.exports